import type { ReactNode } from "react";
import { cn } from "../../utils/cn";

interface FieldProps {
  label?: string;
  htmlFor?: string;
  helper?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  children: ReactNode;
  className?: string;
  labelClass?: string;
}

export function Field({
  label,
  htmlFor,
  helper,
  error,
  required,
  children,
  className,
  labelClass,
}: FieldProps) {
  return (
    <div className={cn("space-y-1.5", className)}>
      {label ? (
        <label htmlFor={htmlFor} className={cn("block text-xs font-medium text-foreground-700", labelClass)}>
          {label}
          {required ? <span className="ml-0.5 text-danger-500">*</span> : null}
        </label>
      ) : null}
      {children}
      {helper && !error ? <p className="text-xs text-foreground-500">{helper}</p> : null}
      {error ? <p className="text-xs text-danger-600">{error}</p> : null}
    </div>
  );
}

export const fieldBaseClass =
  "w-full rounded-md border bg-background-50 px-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400/40 disabled:cursor-not-allowed disabled:bg-background-100 disabled:text-foreground-500";

export function fieldStateClass(error?: ReactNode, className?: string): string {
  return cn(
    fieldBaseClass,
    error ? "border-danger-300 focus:ring-danger-300/30" : "border-background-300",
    className
  );
}